"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UnauthenticatedPaymentsLink_1 = require("./UnauthenticatedPaymentsLink");
exports.default = UnauthenticatedPaymentsLink_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/UnauthenticatedPaymentsLink/index.js
// module id = 1716
// module chunks = 8